import { ApiV2PresentationSimple } from '~/api/v2/organizations/[id]/presentations/get';
import { CardPresentation } from '~/components/Card/CardPresentation';
import { SusnetLink } from '~/components/_wrapper/SusnetLink';

type Props = {
  uid: string;
  organizationName: string;
  organizationLogo?: string;
  presentations: ApiV2PresentationSimple[];
  isLoadingOrgPresentations: boolean;
};

export function TabPanelPresentation({
  uid,
  organizationName,
  organizationLogo,
  presentations,
  isLoadingOrgPresentations,
}: Props) {
  // TODO: UI設計
  return (
    <div className='mx-auto my-[64px] flex w-full max-w-[600px] flex-col'>
      {presentations.map((presentation) => (
        <div key={presentation.id}>
          <CardPresentation
            companyName={organizationName}
            companyLogo={organizationLogo ?? '/icons/corp-icon.png'}
            title={presentation.title}
            link={`/presentations/${presentation.id}`}
            src={presentation.thumbnail}
          />
        </div>
      ))}
    </div>
  );
}
